import { j as e } from "../jsx-runtime-ClSzPYp4.js";
import { styled as n } from "styled-components";
import { Box as m, flexModifiers as a } from "../Flexbox/Flexbox.mjs";
import c from "../typography/Text/Text.mjs";
const f = /* @__PURE__ */ n(m).withConfig({
  componentId: "sc-eab0c268-0"
})([
  "",
  ";",
  ""
], ({ theme: o }) => o.components.badge.base, a), g = ({ backgroundColor: o, color: t, children: r, textProps: s, ...i }) => /* @__PURE__ */ e.jsx(f, {
  backgroundColor: o,
  color: t,
  ...i,
  children: /* @__PURE__ */ e.jsx(c, {
    size: "large",
    fontWeight: "semiBold",
    color: "currentColor",
    ...s,
    children: r
  })
});
export {
  g as default
};
